// src/VKCallback.jsx
import { useEffect } from "react";
import { useNavigate } from 'react-router-dom';

export default function GoCallback({saveToken}) {
  const navigate = useNavigate(); // хук для редиректа
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const utm = localStorage.getItem("utm_source");

    

    fetch("https://im-gpt.ru:3000/api/google/auth", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ code,utm }),
    })
      .then(res => res.json())
      .then(data => {
        if(data?.token) 
        {
            saveToken(data.token);
            window.ym(96157357,'reachGoal','5');
        }
        navigate('/chat'); 
      })
      .catch(err => {
        console.error(err);
        navigate('/chat?login'); 
      });
  }, []);

  return <h1>Авторизация Google...</h1>;
}
